/**
 * Bunny AI Gateway
 * Security-first AI gateway. One API. Every model. Total protection. All `/v1/_*` endpoints are transparently proxied to the underlying AI Gateway runtime. Use a valid API key in the `Authorization` header.
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Expires } from './expires';

export interface ApiKeyPatchRequest {
  status?: ApiKeyPatchRequest.StatusEnum | null;
  name?: string | null;
  models?: string[] | null;
  max_budget?: number | null;
  budget_duration?: string | null;
  expires?: Expires | null;
  metadata?: object | null;
  tpm_limit?: number | null;
  rpm_limit?: number | null;
  max_parallel_requests?: number | null;
  region?: ApiKeyPatchRequest.RegionEnum | null;
}
export namespace ApiKeyPatchRequest {
  export type StatusEnum = 'active' | 'blocked';
  export const StatusEnum = {
    active: 'active' as StatusEnum,
    blocked: 'blocked' as StatusEnum,
  };
  export type RegionEnum = 'eu' | 'us' | 'auto';
  export const RegionEnum = {
    eu: 'eu' as RegionEnum,
    us: 'us' as RegionEnum,
    auto: 'auto' as RegionEnum,
  };
}
